import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M19.8923 17.2916H0.937988L9.90984 0.443359L19.8923 17.2916Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
